import * as actions from '../actions'

// store data
export const getUserInfo = ({ data }) => data.userInfo
export const getWechatUser = ({ data }) => data.wechatUser
export const getNextCerts = ({ data }) => data.nextCerts

export const getEcards = ({ data }) => {
  const { certifications = [], credentials = [] } = data
  return certifications.concat(credentials).sort((c1, c2) => {
    return new Date(c2.issueDate).getTime() - new Date(c1.issueDate).getTime()
  })
}

export const isMember = ({ data }) => data.credentials && data.credentials.length > 0

// 已兑免费首卡证书列表（GET /api/ecommerce/freeFirstCardRedeemed），未加载/失败时为 []
export const getRedeemedFreeCards = ({ data }) => data.redeemedFreeCards || []

export const getProfile = ({ data }) => data.profile

export const getCardRequestOptions = ({ data }, id) => (data.cardRequestOptions ? data.cardRequestOptions[id] : null)

export const getShoppingCart = ({ data }) => data.shoppingCart

export const getAddressList = ({ data }) => data.addressList

export const getClubVip = ({ data }) => {
  if (data.profile) return data.profile.clubVip
}
export const getChangeRight = ({ data }) => {
  if (data.profile) return data.profile.hasChangeRight === 2 || data.profile.hasChangeRight === 1
}

// store entityRequestStatus
export const isRequesting = ({ entityRequestStatus }, entity) =>
  entityRequestStatus[entity] === actions.ENTITY_REQUESTING

//store state
export const getEcardDetail = (id) => (state) => getEcards(state).find((e) => e.uniqueId === decodeURIComponent(id))
//store ui
export const getCartList = ({ ui }) => ui.shoppingCart.cartList

export const getMemberRenew = ({ ui }) => ui.memberRenew

export const getStoreRenew = ({ ui }) => ui.storeRenew

export const getMemberRenewFuiouOrder = ({ ui }) => ui.memberRenewFuiouOrder

export const getStoreRenewFuiouOrder = ({ ui }) => ui.storeRenewFuiouOrder

export const getIeList = ({ owsi }) => owsi.ieListForExaminer
